// @flow

import React from 'react';
import styled from 'styled-components';

const StyledLoaderDiv = styled.div`
  padding: 10px 16px;
  border: 1px solid rgba(0, 0, 0, 0.5);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 1px 1px rgba(0, 0, 0, 0.16),
    0 -1px 3px rgba(0, 0, 0, 0.12), 0 -1px 1px 1px rgba(0, 0, 0, 0.16);
  background: #fff;
  border-radius: 5px;

  .title {
    font-weight: bold;
    border-bottom: 1px solid #ccc;
    padding-bottom: 10px;
    margin-bottom: 10px;
  }

  .controls {
    text-align: right;
    border-top: 1px solid #ccc;
    padding-top: 8px;
    margin-top: 10px;

    > button {
      padding: 4px 16px;
      border: none;
      background: transparent;
      font-size: 0.8rem;
      font-weight: bold;
    }
  }
`;

type Props = {
  title: Node,
  children: Node,
  onClose: (any) => any,
};

export const BieModal = ({title, children, onClose}: Props) => (
  <StyledLoaderDiv>
    <h5 className="title">{title}</h5>
    <div>{children}</div>
    <div className="controls">
      <button onClick={onClose}>Close</button>
    </div>
  </StyledLoaderDiv>
);
